export default "__VITE_ASSET__BNAfZSDm__";